<template>
    <div id="manage-subject-detail" class="flex justify-center items-center w-full h-full p-4">
        <div @click="$emit('close')" class="manage-subject-backdrop absolute pin-t pin-l w-full h-full"></div>
        <div class="manage-content w-full md:w-auto bg-white rounded-lg">
            <div class="manage-header flex justify-between items-center p-4 border-b">
                <h1 class="m-0 font-size-18">
                    {{
                        subject
                            ? $t('manage_school_subjects_detail_header_edit')
                            : $t('manage_school_subjects_detail_header_add')
                    }}
                </h1>
                <div @click="$emit('close')" class="manage-close-button flex justify-center items-center">
                    <i class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                </div>
            </div>
            <form @submit.prevent="submit()" class="manage-body flex flex-col justify-center items-center p-4">
                <div class="form-control flex flex-col w-full">
                    <label>{{ $t('manage_school_subjects_table_header_name') }}</label>
                    <input
                        v-model="form.label"
                        v-validate="'required'"
                        class="manage-subject-input"
                        name="subject-label"
                    />
                    <span v-if="errors.has('subject-label')" class="block mt-1 font-size-16 text-red">
                        <i class="fas fa-exclamation-circle"></i> {{ $t('manage_school_subjects_detail_name_invalid') }}
                    </span>
                </div>

                <XButton
                    :disabled="loading"
                    :bg-color="subject ? '#17a2b8' : '#28a745'"
                    type="submit"
                    class="manage-add-button w-full shadow-text-none"
                    aria-label="Search quiz"
                >
                    {{
                        subject
                            ? $t('manage_school_subjects_detail_button_edit')
                            : $t('manage_school_subjects_detail_button_add')
                    }}
                </XButton>
            </form>
        </div>
    </div>
</template>

<script>
import popup from '@/lib/popup.js'
import helperMixins from '@/mixins/helper'
import XButton from '@/components/v2/XButton'
export default {
    components: {
        XButton
    },

    mixins: [helperMixins],

    props: {
        subjectList: {
            type: Array,
            default: () => []
        },

        subject: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            list: [],
            form: {
                label: '',
                name: '',
                status: true
            },
            loading: false,
            prevSubject: {}
        }
    },

    created() {
        this.list = this.subjectList

        if (this.subject) {
            this.form = Object.assign({}, this.subject)
            this.prevSubject = window.structuredClone(this.form)
        }
    },

    methods: {
        async submit() {
            if (this.loading) return

            const validateResult = await this.$validator.validate()

            if (!validateResult) return

            this.loading = true

            this.form.name = this.slugify(this.form.label)
            this.form.label = this.form.label.trim().replace(/\s+/g, ' ')

            try {
                if (this.subject) {
                    if (this.subject.name === this.form.name) {
                        this.$emit('close')
                        this.loading = false
                        return
                    }

                    if (this.list.find(data => data.name === this.form.name)) {
                        popup.alert(this.$t('manage_school_subjects_alert_subject_exists'))
                        this.loading = false
                        return
                    }

                    const editIndex = this.subjectList.findIndex(data => data.name === this.subject.name)

                    this.list[editIndex] = this.form
                } else {
                    if (this.list.find(data => data.name === this.form.name)) {
                        popup.alert(this.$t('manage_school_subjects_alert_subject_exists'))
                        this.loading = false
                        return
                    }

                    this.list.push(this.form)
                }

                await this.$store.dispatch('updateSubjects', {
                    subjects: this.list,
                    changed_subject: {
                        prev: this.prevSubject,
                        current: this.form
                    }
                })

                if (this.subject) {
                    this.toastSuccess(this.$t('manage_school_subjects_popup_add_subject_complete'))
                } else {
                    this.toastSuccess(this.$t('manage_school_subjects_popup_edit_subject_complete'))
                }

                this.$emit('success')
            } catch {
                this.toastError(this.$t('manage_school_popup_error'))
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style lang="scss">
#manage-subject-detail {
    color: #333;
    .manage-subject-backdrop {
        background-color: rgba(0, 0, 0, 0.3);
        z-index: -1;
    }

    .manage-content {
        @media screen and (min-width: 768px) {
            max-width: 500px;
            min-width: 400px;
        }

        .manage-header {
            border-bottom: 1px solid #ced4da;

            .manage-close-button {
                width: 1.5rem;
                height: 1.5rem;
            }
        }

        .manage-body {
            row-gap: 1rem;

            .form-control {
                row-gap: 7px;

                .manage-subject-input {
                    height: 40px;
                    border-radius: 0.5rem;
                    padding: 10.5px 10.5px 10.5px;
                    border: 1px solid #ced4da;
                    font-size: 14px;
                    color: #333;
                }
            }

            .manage-add-button {
                border-radius: 0.5rem;
            }
        }
    }
}
</style>
